
const normalizeApiUrl = (url) => {
  const fallback = "https://rustic.productos-api.com/";
  const value = url || fallback;
  return value.endsWith("/") ? value : `${value}/`;
};

const runtimeConfig =
  typeof window !== "undefined" ? window.__RUSTIC_CONFIG__ : undefined;

export const STRINGS_ENV = {
  appName: "Rustic World",
  email: "pepejoe99.08@gmail.com",
  phone: "+1 (520) 987-1861",
  address: "1111 Hwy 243, Canton, TX 75103, US.",
  theme: "Discover the best rustic products for your home. Unique and personalized designs.",
  rights: "© 2025 Rustic World. All rights reserved.",

  apiUrl: normalizeApiUrl(runtimeConfig?.apiUrl || process.env.REACT_APP_API_URL),

  // Auth
  loginMessage: "Enter your account to begin the expirience",
  loginSuccess: "Welcome back!",
  logoutSuccess: "You have been logged out.",
  loginError: "Valid email is required.",
  loginError2: "Emails do not match.",
  passwordError: "Password must be at least 6 characters.",
  passwordError2: "Password do not match.",
  registerMessage: "You do not have an account yet? ",
  registerMessage2: "Register now and get full access to our app.",
  registerSuccess: "Your account has been created!",
  registerError: "There was a problem creating your account.",
  registerNameError: "First name is required (min 2 characters).",
  registerLastNameError: "Last name is required (min 2 characters).",
  registerAddressError: "Address is required (min 5 characters).",
  registerPhoneError: "Phone must be exactly 10 digits and contain only numbers.",

  // Routes
  productRoute: "product",
  productWithSKURoute: "product/:productSku",
  orderRoute: "order",
  cartRoute: "cart",
  signinRoute: "signin",
  loginRoute: "login",

  // Cart
  cartEmpty: "Start adding some awesome products!",
  addedToCart: "Product added to cart!",
  removedFromCart: "Product removed from cart.",

  // Products
  productNotFound: "Product not found.",
  productAddedSuccess: "Product added successfully.",
  productUpdatedSuccess: "Product updated successfully.",

  // Errors
  genericError: "Something went wrong. Please try again.",
  notAuthorized: "You are not authorized to perform this action.",
  networkError: "A network error occurred. Please check your connection.",

  // UI Labels
  confirm: "Confirm",
  cancel: "Cancel",
  close: "Close",
  delete: "Delete",
  edit: "Edit",
  save: "Save",
  submit: "Submit",
  searchPlaceholder: "Search products or categories...",

  // Alerts
  alertLoginRequired: "You must log in to add it to the cart",
  alertItemAdded: "Your item has been added to the cart",
  alertGenerateOrder:
    "Order created successfully." +
    "A confirmation email has been sent to your address " +
    "from pepejoe99.08@gmail.com" +
    "📬 If you do not see it, please check your spam or promotions folder.",
  alertOrderCanceled: "Your order has been canceled succesfully.",
  alertOrderErrorUnknown: "There is a unknown server error, please try again later.",

  // Order status
  orderCreated: "created",
  orderCanceled: "canceled",

  // Local storage
  localstorageToken: "access_token",
  localStorageCartItems: "cart_items",
  localStorageCartDate: "cart_selected_date",
};
